import * as CSS from 'csstype';
import * as React from 'react';

type Props = {
    collapsed: boolean,
    title: string,
    children: React.ReactNode,
}

export default function Collapsible(
    {
        collapsed,
        title,
        children
    }: Props): JSX.Element {
    const [isCollapsed, setIsCollapsed] = React.useState(collapsed);
    return (
        <div style={collapseComponent}>
            <div
                style={collapseButton}
                onClick={() => setIsCollapsed(!isCollapsed)}
            >
                {isCollapsed ? 	'▶' : '▼' } <span className='no-underline hover:underline'>{title}</span>
            </div>
            <div
                style={isCollapsed ? collapseContentCollapsed : collapseContentExpanded}
                aria-expanded={isCollapsed}
            >
                {children}
            </div>
        </div>
    );
}

const collapseButton: CSS.Properties = {
    display: 'block',
    width: '100%',
    alignItems: 'flex-start',
    color: '#004FC2',
    margin: '3px 0',
}

const collapseContentCollapsed: CSS.Properties = {
    display: 'none',
}

const collapseContentExpanded: CSS.Properties = {
    display: 'block',
}

const collapseComponent: CSS.Properties = {
    color: 'text-gray-700',
    fontSize: '16px'
}